import React, { useState } from "react";
import { FileUpload } from "primereact/fileupload";
import * as styles from "./../ImportModal.module.css";

export const ImportModalContent = ({ uploadRef, onFileUpload }) => {
  const [fileName, setFileName] = useState(null);

  return (
    <FileUpload
      ref={uploadRef}
      mode="advanced"
      accept="text/csv, text/plain"
      customUpload
      uploadHandler={onFileUpload}
      auto={false}
      chooseLabel="Choose file"
      onSelect={(e) => {
        setFileName(e.files[0]?.name);
      }}
      itemTemplate={() => <div>{fileName}</div>}
      emptyTemplate={
        <div
          className={styles.uploadContent}
          onClick={() => {
            uploadRef.current?.getInput()?.click();
          }}
        >
          <svg
            className={styles.uploadIcon}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30.001 22.6382C30.6144 22.6383 31.1121 23.1361 31.1123 23.7495V27.4995C31.1123 29.3623 29.7333 31.1105 27.7764 31.1108H12.2256C10.2683 31.1108 8.88867 29.3625 8.88867 27.4995V23.7495C8.88891 23.136 9.38648 22.6382 10 22.6382C10.6134 22.6383 11.1111 23.1361 11.1113 23.7495V27.4995C11.1113 28.3865 11.7327 28.8882 12.2256 28.8882H27.7764C28.2691 28.8878 28.8896 28.3862 28.8896 27.4995V23.7495C28.8899 23.1361 29.3875 22.6382 30.001 22.6382ZM20.0273 8.89014C20.0485 8.89058 20.0697 8.89142 20.0908 8.89307C20.1105 8.89451 20.13 8.89647 20.1494 8.89893C20.1566 8.89987 20.1637 8.90078 20.1709 8.90186C20.1986 8.90591 20.226 8.91045 20.2529 8.9165C20.2559 8.91717 20.2588 8.91777 20.2617 8.91846C20.4935 8.97245 20.6968 9.09913 20.8477 9.27295L25.7891 14.2144C26.2229 14.6483 26.2229 15.3517 25.7891 15.7856C25.3551 16.2192 24.6516 16.2194 24.2178 15.7856L21.1201 12.688V23.7505C21.12 24.3641 20.6224 24.8618 20.0088 24.8618C19.3952 24.8618 18.8975 24.3641 18.8975 23.7505V12.6772L15.79 15.7856C15.3561 16.2193 14.6516 16.2195 14.2178 15.7856C13.7843 15.3519 13.7845 14.6482 14.2178 14.2144L19.2178 9.21436L19.3027 9.13818C19.4454 9.02189 19.6107 8.9464 19.7822 8.91162C19.7852 8.91101 19.7881 8.91025 19.791 8.90967C19.8227 8.90351 19.8547 8.89938 19.8867 8.896C19.8945 8.89515 19.9023 8.89473 19.9102 8.89404C19.9368 8.89179 19.9635 8.89047 19.9902 8.89014C19.9964 8.89004 20.0026 8.88916 20.0088 8.88916C20.015 8.88916 20.0212 8.89004 20.0273 8.89014Z"
              fill="black"
            />
          </svg>

          <div className={styles.importModalTextContent}>
            <p className={styles.importModalText}>
              Drag and drop or{" "}
              <span className={styles.chooseLink}>Choose file</span> to upload
            </p>

            <span>CVS or TXT</span>
          </div>
        </div>
      }
    />
  );
};
